import { ModalService } from './modal.service';

export const Services = [
	ModalService,
];
